export default __webpack_public_path__ + "src/assets/walletconnect.7de769ce1ae236e10c32061c14b483f6.svg";